import { LayerChange } from 'providers/LayerChangesProvider/types'
import { ICONS, VERBS } from 'components/TrackedChange/TrackedChangeItem/constants'
import Styles from 'components/TrackedChange/TrackedChangeItem/TrackedChangeMetadata.module.scss'
import { useAuth } from 'hooks/UseAuth'
import { Profile } from 'types'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { forwardRef } from 'react'

interface Props {
  type: LayerChange['type']
}

export const TrackedChangeIcon = forwardRef<HTMLDivElement, Props>(({ type, ...rest }, fRef) => {
  const Icon = ICONS[type]

  return (
    <div className={Styles.icon} {...rest} ref={fRef}>
      <Icon />
    </div>
  )
})

export const TrackedChangeIconWithTooltip = ({ type, user }: Props & { user?: Profile }) => {
  const auth = useAuth()
  const userName = user?.display_name || 'Anonymous'
  const isUser = auth && auth.id === user?.id
  const displayName = isUser ? 'You' : userName

  return (
    <Tooltip placement="top" label={`${displayName} ${VERBS[type]}`}>
      <TrackedChangeIcon type={type} />
    </Tooltip>
  )
}
